import useDegreeLearnerMemberships from 'bundles/degree-home/components/v3-dpm/lib/useDegreeLearnerMemberships';
import useDegree from 'bundles/degree-home/utils/useDegree';
import useDegreeHomeAdminPermissions from 'bundles/degree-home/utils/useDegreeHomeAdminPermissions';

export type MembershipStatus = 'member' | 'not_member' | 'data_loading';
export type LoadedMembershipStatus = Exclude<MembershipStatus, 'data_loading'>;

/** Determine whether the current learner is part of a degree or not */
const useDegreeMembershipStatus = (degreeId?: string): MembershipStatus => {
  const { data: membershipsData, loading: membershipsLoading } = useDegreeLearnerMemberships();
  const { data: degreeData, loading: degreeLoading } = useDegree();
  const { adminPermissions, adminPermissionDataLoading } = useDegreeHomeAdminPermissions();

  if (membershipsLoading || adminPermissionDataLoading || degreeLoading || !degreeId) {
    return 'data_loading';
  }

  const degreeMembership = membershipsData?.DegreeLearnerMembershipsV1Resource?.byUser?.elements;

  const isLearnerOfDegree = (degreeMembership ?? []).find(
    (membership) => membership?.degree?.id === degreeId && membership?.role === 'LEARNER'
  );

  const isAdminOfDegree = adminPermissions && Boolean(adminPermissions?.canViewDegreeById?.(degreeId));
  const canViewDegree = isLearnerOfDegree || isAdminOfDegree;

  if (!degreeData) {
    return 'not_member';
  }

  return canViewDegree ? 'member' : 'not_member';
};

export default useDegreeMembershipStatus;
